module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('c-action-sheet', {
    attrs: {
      "visible": _vm.visibleInline
    },
    on: {
      "update:visible": function($event) {
        _vm.visibleInline = $event
      }
    }
  }, [_c('p', {
    staticClass: "divider"
  }, [_c('span', {
    staticClass: "divider-inner-text"
  }, [_vm._v("分享到")])]), _vm._v(" "), _c('ul', {
    staticClass: "box"
  }, [_c('li', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.shareTo(_vm.enumObj.wechat)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "http://res.laoban100.com/app-comm/assets/images/mallview/FrbIDqzdMGkMpGJpwq5HNGjuRNwM.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("微信")])]), _vm._v(" "), _c('li', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.shareTo(_vm.enumObj.wechatTimeline)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "http://res.laoban100.com/app-comm/assets/images/mallview/FkhslI14-_hVzE4bamXuOQMUa7xW.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("朋友圈")])]), _vm._v(" "), _c('li', {
    staticClass: "item clip-btn",
    attrs: {
      "data-clipboard-text": _vm.href
    }
  }, [_c('img', {
    attrs: {
      "src": "http://res.laoban100.com/app-comm/assets/images/mallview/FkPpOwWCI1MFNixljOYfvneTqECA.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("复制链接")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d281e82","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/invite/share.vue
// module id = 1052
// module chunks = 2